// extracted by mini-css-extract-plugin
module.exports = {"services":"Index-module--services--3TWk5","whyUs":"Index-module--whyUs--1pI30","posts":"Index-module--posts--1MUeU"};